<template>
    <div>
        <div class="relative pl-7 pr-6 overflow-hidden">
            <div class="loveSlider mx-auto">
                <ReviewAvatar
                    v-for="(testimonial, index) in notHidedTestimonials"
                    :key="testimonial.id"
                    :wall="wall"
                    :testimonial="testimonial"
                    :is-selected="selectedTestimonialIndex === index"
                    @mouseenter="changeSelectedTestimonial(index)"
                />
            </div>

            <div
                class="love-avatars-slider-arrow-left absolute top-0 left-0 w-12 h-12 rounded-full border-2 cursor-pointer flex items-center justify-center aria-disabled:opacity-0"
                :style="{
                    color: wall.textColor,
                    'background-color': wall.backColor,
                    'border-color': wall.borderColor,
                }"
            >
                <ChevronLeftIcon class="h-5 w-5" />
            </div>
            <div
                class="love-avatars-slider-arrow-right absolute top-0 right-0 w-12 h-12 rounded-full border-2 cursor-pointer flex items-center justify-center aria-disabled:opacity-0"
                :style="{
                    color: wall.textColor,
                    'background-color': wall.backColor,
                    'border-color': wall.borderColor,
                }"
            >
                <ChevronRightIcon class="h-5 w-5" />
            </div>
        </div>
        <transition name="fade" mode="out-in">
            <ReviewContent
                v-if="selectedTestimonial.id"
                :wall="wall"
                :testimonial="selectedTestimonial"
                :key="selectedTestimonial.id"
            />
        </transition>
    </div>
</template>

<style>
.tns-outer {
    margin-left: -8px;
}

.tns-inner {
    padding-left: 8px;
}
</style>

<script>
import ReviewAvatar from "./avatars/ReviewAvatar.vue";
import ReviewContent from "./avatars/ReviewContent.vue";
import { ChevronLeftIcon, ChevronRightIcon } from "@easy/ui/icons";
import { tns } from "tiny-slider/src/tiny-slider";

export default {
    name: "LoveAvatars",
    props: {
        wall: Object,
    },
    emits: ["updateIframe"],
    data() {
        return {
            selectedTestimonialIndex: null,
        };
    },
    components: {
        ReviewAvatar,
        ReviewContent,
        ChevronRightIcon,
        ChevronLeftIcon,
    },
    mounted() {
        this.startSlider();
    },
    beforeUnmount() {
        this.destroySlider();
    },
    computed: {
        notHidedTestimonials() {
            const notHidedTestimonials = this.wall.testimonials.filter(
                (x) => !x.hide && !x._deleted && x.isPublished
            );

            if (this.wall.showOnlyWithAvatar) {
                return notHidedTestimonials.filter((x) => x.photo);
            }
            return notHidedTestimonials;
        },
        selectedTestimonial() {
            return this.notHidedTestimonials[this.selectedTestimonialIndex] || {};
        },
        testimonialsLength() {
            return this.notHidedTestimonials.length;
        },
    },
    watch: {
        testimonialsLength: {
            handler: function () {
                this.refreshSlider();
            },
        },
    },
    methods: {
        changeSelectedTestimonial(index) {
            this.selectedTestimonialIndex = index;
            this.$nextTick(() => {
                this.$emit("updateIframe");
            });
        },
        startSlider() {
            "undefined" != typeof tns &&
                document.querySelector(".loveSlider") &&
                !document.querySelector(".loveSlider.tns-slider") &&
                (this.loveSlider = tns({
                    container: ".loveSlider",
                    fixedWidth: 40,
                    slideBy: "page",
                    nextButton: document.querySelector(".love-avatars-slider-arrow-right"),
                    prevButton: document.querySelector(".love-avatars-slider-arrow-left"),
                    loop: !1,
                    nav: false,
                }));
        },
        destroySlider() {
            this.loveSlider?.destroy && this.loveSlider.destroy();
        },
        refreshSlider() {
            setTimeout(() => {
                this.loveSlider?.rebuild && this.loveSlider.rebuild();
            }, 300);
        },
    },
};
</script>
